<template>
  <div>
    <!-- 左侧返回和首页 -->
    <div class="left-caozuoicon">
      <div style="cursor: pointer;" @click="goBack">
        <i class="el-icon-back"></i>
      </div>
      <div style="cursor: pointer;" @click="goHome">
        <i class="el-icon-s-home"></i>
      </div>

      <div class="pages-tab">
        <el-tag size="medium" effect="dark" closable @close="goBack">
          <i :class="nowRouteIcon"></i>
          <span style="margin-left: 5px">{{ nowRouteName }}</span>
        </el-tag>
      </div>
    </div>

    <!-- 右侧用户登录图标 -->
    <div class="user-logininfo">
      <!-- 顶部搜索框 -->
      <HeaderSeach />
      <el-dropdown @command="clickmenu">
        <span class="el-dropdown-link right-userName">
          <div class="nickName">{{ userInfo.nickName }}</div>
          <div class="image">
            <img src="../../assets/railway.png" alt srcset />
          </div>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="outlogin">退出登录</el-dropdown-item>
          <el-dropdown-item command="userInfo">个人中心</el-dropdown-item>
          <el-dropdown-item command="systemClear">清理缓存</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { getUserInfo } from "@/api/admin-service/user";
import { getMenuTree } from "@/api/admin-service/menu";
import HeaderSeach from "./HeaderSearch";
export default {
  components: {
    HeaderSeach
  },
  data() {
    return {
      // 获取当前页面名称
      nowRouteName: "",
      nowRouteIcon: "",
      userInfo: "",
      activeApp: ""
    };
  },
  mounted() {
    // 设置标题
    // 获取用户信息
    let access_token = localStorage.getItem("access_token");
    if (access_token) {
      this.setNowRouteName(this.$route);
      this.getUserInfo();
    }
  },

  methods: {
    // 获取用户信息
    getUserInfo() {
      getUserInfo().then(res => {
        const { data } = res || {};
        this.userInfo = data;
      });
    },
    // 获取当前页面标题
    setNowRouteName(route) {
      this.nowRouteName = route.meta.title;
      getMenuTree({
        userId: this.userInfo.userId
      }).then(r => {
        const excludedMenuNames = ["1c", "2c", "3c", "4c", "5c"];
        // 使用 toLowerCase 转换 item.menuName 为小写后进行排除
        const filteredMenuData = (r.data || []).filter(
          item => !excludedMenuNames.includes(item.menuName.toLowerCase())
        );
        // 递归函数来查找匹配的 path 并设置 this.nowRouteIcon
        const findIcon = menuList => {
          for (let item of menuList) {
            // 如果找到路径匹配的菜单项
            if (item.path === route.path) {
              this.nowRouteIcon = item.icon;
              return; // 找到后立即返回
            }

            // 如果有子菜单，递归处理子菜单
            if (item.children && item.children.length > 0) {
              findIcon(item.children);
            }
          }
        };
        // 调用递归函数来处理 filteredMenuData
        findIcon(filteredMenuData);
      });
    },
    // 关闭标签事件
    goBack() {
      // 判断浏览器历史记录的长度
      if (window.history.length <= 2) {
        // 如果历史记录长度小于等于2，跳转到首页
        this.goHome();
      } else {
        // 如果历史记录长度大于2，返回上一页
        this.$router.go(-1);
      }
    },
    // 回到首页
    goHome() {
      // 判断当前路径是否是 '/homepage'
      if (this.$route.path === "/homePage") {
        // 如果当前已经是 /homepage，刷新页面
        window.location.reload();
      } else {
        // 如果当前路径不是 /homepage，使用 replace 跳转到 /homepage
        this.$router.replace("/homePage");
      }
    },
    // 点击下拉菜单回调
    clickmenu(e) {
      if (e === "outlogin") {
        this.outLogin();
      } else if (e === "userInfo") {
        this.userInfos();
      } else if (e === 'systemClear') {
        localStorage.clear();
        sessionStorage.clear();
        window.location.reload()
      }
    },
    // 退出登录
    outLogin() {
      // 回到首页
      localStorage.removeItem("access_token");
      this.$router.replace("/login");
    },
    // 用户中心
    userInfos() {
      this.$router.replace("/userInfo");
    }
  },
  watch: {
    $route: function (newRoute) {
      this.setNowRouteName(newRoute);
    }
  }
};
</script>

<style lang="less" scoped>
// 左侧操作图标
.left-caozuoicon {
  display: flex;
  align-items: center;
  gap: 30px;

  padding-left: 20px;
  box-sizing: border-box;

  .pages-tab {
    display: flex;
    height: 40px;
    justify-content: center;
    align-items: center;
    gap: 15px;
  }
}

// 右侧用户头像
.user-logininfo {
  display: flex;
  align-items: center;
  position: fixed;
  right: 20px;
  gap: 10px;
  cursor: pointer;

  .image {
    width: 30px;
    height: 30px;
    border-radius: 15px;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
    }
  }
}

.right-userName {
  display: flex;
  align-items: center;
  gap: 10px;
}

.nickName {
  font-size: 12px;
  color: red;
}
</style>